import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

interface StepBookingProps {
    currentStep: number
}

const steps = [
    { name: 'words_title.information_reservation' },
    { name: 'booking_bike.title.confirmation' }
];

export default observer(function StepProgress({ currentStep }: StepBookingProps) {
    const { t } = useTranslation();

    return (
        <div className='flex justify-between w-[80%] items-center mt-6 mx-auto'>
            {steps.map((step, index) => (
                <>
                    {
                        index > 0 && (
                            <div
                                className={`w-full h-[2px] mx-4
                            ${index < currentStep ? 'bg-red-500' : 'bg-gray-300 opacity-60'}`}
                            >
                            </div>
                        )
                    }
                    <div key={index} className='flex justify-between items-center relative'>

                        <div
                            className={`w-8 h-8 flex items-center justify-center rounded-full border-2
                        ${index < currentStep ? 'border-[#DE0001] bg-[#DE0001] text-white text-[14px]' : ' bg-gray-200 text-gray-600 opacity-60 text-[14px]'}
                        `}
                        >
                            {index + 1 < currentStep ? <Check size={14} strokeWidth={2} /> : index + 1}
                        </div>

                        <p className={`ml-2 text-[16px] text-nowrap ${index < currentStep ? 'text-black' : 'text-gray-500'}`}>
                            {t(step.name)}
                        </p>
                    </div>
                </>

            ))}
        </div>
    );
});
